import api from '@/api/information';

export default {
  state: {
    reports: null,
    publicAnswers: null,
    allPublicAnswers: null
  },

    getters: {
      reports: (state) => state.reports,
      publicAnswers: (state) => state.publicAnswers,
      allPublicAnswers: (state) => state.allPublicAnswers
    },

    actions: {
      async getReports({ commit }) {
        try{
          const response = await api.fetchReports();

          commit('SET_REPORTS', response.data);
        }
        catch (error){
          return Promise.reject(error.response);
        }
      },

      async getPublicAnswers({ commit, state }, filters = null) {
        const pairs = Object.entries(filters);
        const queryString = pairs.map(([chave, valor]) => `${chave}=${valor}`).join('&');

        try{
          const response = filters ? await api.fetchPublicAnswers(`?${queryString}`)
          : await api.fetchPublicAnswers();

          commit('SET_PUBLIC_ANSWERS', response.data.data);

          if (!state.allPublicAnswers) {
            const allAnswers = await api.fetchPublicAnswers();

            commit('ALL_PUBLIC_ANSWERS', allAnswers.data.data);
          }
        }
        catch (error){
          return Promise.reject(error.response);
        }
      }
    },

  mutations: {
    SET_REPORTS(state, payload) {
      state.reports = payload;
    },

    SET_PUBLIC_ANSWERS(state, payload) {
      state.publicAnswers = payload;
    },

    ALL_PUBLIC_ANSWERS(state, payload) {
      state.allPublicAnswers = payload;
    }
  }
};
